<template>
  <div class="document-container">
    <ul class="summary-panels--width summary-panels wrap is-flex">
      <!-- <li
        class="document flex-item flex-item-header grow"
        v-if="hasModule('DRMCH:CEP:MGR:VIEW')"
      >
        <div
          v-if="pendingLoading"
          style="height:100%"
          class="is-flex grow"
        >
          <div class="is-flex flex-align--center flex-justify--center grow">
            <es-loader size="2x"/>
          </div>
        </div>
        <dm-dash-pending-work
          v-if="!pendingLoading && !pendingLoadingError"
          header="Pending Work"
          :summary="cepSummary"
          :pendingPopulation="pendingPopulation"
          :pendingElection="pendingElection"
        />
        <div
          v-if="!pendingLoading && pendingLoadingError"
          class="is-flex"
        >
          <div class="grow is-flex">
            <es-exception
              exceptionMessage="Error Loading Pending Work"
              margin="2rem"
              class="grow"
            />
          </div>
        </div>
      </li> -->
      <li
        v-if="hasModule('DRMCH:OTHR:VIEW:STATE')"
        class="document flex-item grow"
      >
        <div
          v-if="summaryLoading"
          style="height:100%"
          class="is-flex grow"
        >
          <div class="is-flex flex-align--center flex-justify--center grow">
            <es-loader size="2x"/>
          </div>
        </div>
        <dm-dash-summary v-if="!summaryLoading && !summaryLoadingError">
          <template #header>
            <span>
              {{
                (isStateUser) ? 'State' : getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:DISTRICT_CODE`)
              }} Summary
            </span>
          </template>
          <template #summary-category>
            <span class="has-text-grey has-text-weight-bold">
              {{
                (isStateUser)
                  ? getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:DISTRICT_CODE`)
                  : getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:SCHOOL_CODE`)
              }}(s)
            </span>
          </template>
          <template #summary-number>
            <span class="is-size-5 has-text-weight-bold">
              {{ summaryCount }}
            </span>
          </template>
        </dm-dash-summary>
        <div
          v-if="!summaryLoading && summaryLoadingError"
          class="is-flex"
        >
          <div class="grow is-flex">
            <es-exception
              exceptionMessage="Error Loading Location Summary"
              margin="2rem"
              class="grow"
            />
          </div>
        </div>
      </li>
    </ul>
    <dm-dash-recent-activity
      v-if="hasModule('DRMCH:MATCH:HISTORY:VIEW')"
      class="margin-bottom"
    />
    <div
      v-if="hasModule('DRMCH:MATCH:OPTIONS:VIEW')
        || hasModule('DRMCH:CEP:MGR:VIEW')"
      class="document dashboard-width--small margin-lefft--zero"
    >
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">
              Quick Tips
            </div>
          </template>
        </es-header>
      </div>
      <div class="content">
        <h4 class="title is-4 is-marginless has-text-left">
          Welcome to DirectMatch!
        </h4>
        <div class="quicktip-subtitle has-text-left">
          This is your all-in-one place to match.
        </div>
        <div class="summary-panels wrap is-flex">
          <dm-dash-manager-shortcut
            v-if="hasModule('DRMCH:MATCH:OPTIONS:VIEW')"
            icon="check-circle"
            header="Match Options"
            body="Perform matches of person or address data from a file or Uniq-ID®"
            href="matchOptionsDirectMatch"
            :button="`${this.properties['BUTTON_LABEL-ASSIGN_EXISTING']}`"
          />
          <dm-dash-manager-shortcut
            v-if="hasModule('DRMCH:CEP:MGR:VIEW')"
            icon="abacus"
            header="CEP Manager"
            body="View, update and certify your Population and Election data."
            href="cepPopulation"
            button="Manage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAbacus,
  faCheckCircle,
} from '@fortawesome/pro-light-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import DmDashManagerShortcut from '@/components/DmDashManagerShortcut.vue';
import DmDashRecentActivity from '@/components/DmDashRecentActivity.vue';
import DmDashSummary from '@/components/DmDashSummary.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import EsLoader from '@/components/EsLoader.vue';
import EsException from '@/components/EsException.vue';
import PermissionManager from '@/mixins/PermissionManager';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faAbacus,
  faCheckCircle,
);

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
    FieldLabels,
  ],
  components: {
    DmDashManagerShortcut,
    DmDashRecentActivity,
    DmDashSummary,
    EsHeader,
    EsLoader,
    EsException,
  },
  data() {
    return {
      cepSummary: [],
      dmHistory: [],
      pendingWork: [],
      pendingLoading: true,
      pendingLoadingError: false,
      pendingPopulation: null,
      pendingElection: null,
      summaryLoading: true,
      summaryLoadingError: false,
      summaryCount: '--',
    };
  },
  async created() {
    this.setBreadcrumb([
      { text: 'Home', to: {} },
    ]);

    this.loadSummary();
    await this.loadPersonTypes();

    if (this.hasModule('DRMCH:CEP:MGR:VIEW')) {
      this.loadPendingWork();
    }
  },
  computed: {
    ...mapGetters([
      'isStateUser',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'defaultPersonType',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    async loadPendingWork() {
      try {
        const responses = await Promise.all([
          axios.get('/cep/stats/pending/population'),
          axios.get('cep/stats/pending/elections'),
        ]);

        const [pop, elec] = responses;

        this.pendingPopulation = pop.data;
        this.pendingElection = elec.data;
      } catch (e) {
        this.pendingLoadingError = true;
      } finally {
        this.pendingLoading = false;
      }
    },
    async loadSummary() {
      const api = (this.isStateUser) ? 'districts' : 'schools';
      try {
        const res = await axios.get(api);
        this.summaryCount = res.data.totalCount;
      } catch (e) {
        this.summaryLoadingError = true;
      } finally {
        this.summaryLoading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .quicktip-subtitle
    margin-bottom: 1rem
    margin-top: 0.5rem
  .content
    padding-top: 1rem
    padding-bottom: 1rem
  .wrap
    -webkit-flex-wrap: wrap
    flex-wrap: wrap
  .summary-panels
    margin-right: -1rem
  .summary-panels--width
    max-width: calc(352px + 1rem)
  .dashboard-width--small
    max-width: 769px
  .flex-item
    width: 300px
    min-height: 80px
    margin: 0rem 1rem 1rem 0rem
  .flex-item-header
    width: 350px
  .grow
    flex-grow: 1
  .margin-bottom
    margin-bottom: 1rem
  .margin-lefft--zero
    margin-left: 0
</style>
